import { render } from "./sv-virtual-scroll.vue?vue&type=template&id=50719e12&scoped=true&ts=true"
import script from "./sv-virtual-scroll.ts?vue&type=script&lang=ts&external"
export * from "./sv-virtual-scroll.ts?vue&type=script&lang=ts&external"

import "./sv-virtual-scroll.vue?vue&type=style&index=0&id=50719e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50719e12"]])

export default __exports__